<template>
    <v-form v-model="valid" ref="form">
        <v-card>
            <v-card-title>
                <span class="headline">{{title}}</span>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-text-field v-model="name" :rules="[(v) => !!v || 'Name is required']" label="Name"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field v-model="description" :rules="[(v) => !!v || 'Description is required']" label="Description"></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="$emit('update:dialog', false)">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save" :disabled="!valid">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>
    import ComponentService from '@/services/ComponentService';
    import MealService from '@/services/MealService';
    import { mapGetters } from 'vuex';

    export default {
      data() {
        return {
            valid: false,
            name: null,
            description: null
        };
      },
      props: {
        meal: Object,
        foods: Array,
        title: String
      },
      watch: {
        meal: {
          immediate: 'true',
          handler() {
            if (this.meal) {
                const meal =  Object.assign({}, this.meal);
                this.description = meal.description;
                this.name = meal.name;
            }
          }
        }
      },
      computed: {
        ...mapGetters({
          user: 'getUser'
        })
      },
      methods: {
        async save() {
          try {
            if (this.$refs.form.validate()) {
              this.$emit('update:loading', true);
              const item = Object.assign({}, this.meal);
              item.userId = this.user.id;
              item.name = this.name;
              item.description = this.description;
              const foods = this.foods;
              const response = await ComponentService.createComponent(item, foods);
              if (this.meal) {
                const { data } = await ComponentService.getComponent(response.data.id);
                for (const food of data.foods) {
                  food.component = data.id;
                }

                this.meal.foods = data.foods;
                await MealService.updateMeal(this.meal);
                for (const food of this.meal.foods) {
                    food.component = null;
                    food.toRemove = true;
                }
                await MealService.updateMeal(this.meal);
              }
              const { data } = await ComponentService.getComponents();
              this.$store.dispatch('setComponents', data);
              this.$emit('snackbar', 'Ingredient created!', 'blue-grey');
              this.$emit('refreshDay');
            }
          } catch (e) {
            this.$emit('snackbar', e.message, 'error');
          } finally {
            this.$emit('update:dialog', false);
            this.$emit('update:loading', false);
          }
        }
      }
    };
</script>